import { ImgHTMLAttributes, ReactNode } from 'react'

export type AvatarElement = HTMLSpanElement
export const AvatarColors = ['primary', 'secondary', 'tertiary', 'neutral'] as const
export type AvatarColor = (typeof AvatarColors)[number]
export const AvatarSizes = ['sm', 'md', 'lg', 'xl', '2xl'] as const
export type AvatarSize = (typeof AvatarSizes)[number]

export interface AvatarProps extends ImgHTMLAttributes<HTMLImageElement> {
  children?: ReactNode
  size?: AvatarSize
  color?: AvatarColor
  className?: string
}
